// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DetachOrMoveController from "./detach_or_move_controller"
application.register("detach-or-move", DetachOrMoveController)

import EmojiChipPickerController from "./emoji_chip_picker_controller"
application.register("emoji-chip-picker", EmojiChipPickerController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import EmojiRatingFieldController from "./emoji_rating_field_controller"
application.register("emoji-rating-field", EmojiRatingFieldController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GaugeEmojiLogController from "./gauge_emoji_log_controller"
application.register("gauge-emoji-log", GaugeEmojiLogController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import PatternModeController from "./pattern_mode_controller"
application.register("pattern-mode", PatternModeController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
